import { zip } from '../array-utils';

export class StringUtils {
    public static slugify(text: string): string {
        return text.toLowerCase()
            .replace(/\s+/g, '-')           // Replace spaces with -
            .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
            .replace(/\-\-+/g, '-')         // Replace multiple - with single -
            .replace(/^-+/, '')             // Trim - from start of text
            .replace(/-+$/, '');            // Trim - from end of text
    }

    public static findPrefixes(str: string, separator: string): string[] {
        const segments = str.split(separator);
        return segments.reduceRight<string[]>((prev, _curr, i, arr) => {
            const prefix = arr.slice(0, i + 1).join(separator);
            prev.push(prefix);
            return prev;
        }, []);
    }

    public static chainParser<T = unknown>(value: T, ctxName: string): string {
        const isOR = /\|\|/;
        const isAND = /\&\&/;
        const isNegative = /\!/;
        const splitValues = String(value).split(' ');

        const logicalValues = [];
        const values = [];

        for (let i = 0; i < splitValues.length; i++) {
            if (isOR.test(splitValues[i]) || isAND.test(splitValues[i])) {
                logicalValues.push(splitValues[i]);
            } else {
                const firstChar = splitValues[i].substr(0, 1);
                if (isNegative.test(firstChar)) {
                    values.push(`!${ctxName}.${splitValues[i].substr(1, splitValues[i].length)}`);
                } else {
                    values.push(`${ctxName}.${splitValues[i]}`);
                }
            }
        }

        return zip(values, logicalValues).flat(Infinity).join(' ');
    }

    public static join(separator: string, ...params: string[]): string {
        return params.filter(x => x && x.length > 0).join(separator);
    }
}

export function upperFirst(text: string): string {
    return text[0].toUpperCase() + text.slice(1);
}
